
export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-green-800 mb-4">
            会社概要
          </h3>
          <div className="w-24 h-1 bg-yellow-500 mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://readdy.ai/api/search-image?query=Modern%20Japanese%20office%20building%20exterior%20with%20clean%20architecture%2C%20professional%20business%20environment%2C%20glass%20windows%20reflecting%20blue%20sky%2C%20urban%20setting%20in%20Osaka%2C%20contemporary%20corporate%20headquarters%2C%20well-maintained%20entrance%20area%20with%20landscaping&width=600&height=400&seq=company-building&orientation=landscape"
              alt="株式会社MELM本社ビル"
              className="w-full h-96 object-cover rounded-lg shadow-lg border-4 border-yellow-400"
            />
          </div>
          
          <div className="space-y-6">
            <div className="bg-yellow-50 p-6 rounded-lg border-l-4 border-green-800">
              <h4 className="text-2xl font-bold text-green-800 mb-4">
                <strong>私たちの使命</strong>
              </h4>
              <p className="text-gray-700 leading-relaxed text-lg">
                美容の可能性を広げ、お客様の美しさを引き出すことを使命としています。
                長年の経験と最新の技術を融合し、安全で効果的な美容商材を提供いたします。
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                <div className="w-12 h-12 bg-green-800 rounded-full flex items-center justify-center mb-3">
                  <i className="ri-award-line text-white text-xl"></i>
                </div>
                <h5 className="font-bold text-green-800 mb-2">高品質保証</h5>
                <p className="text-sm text-gray-600">厳格な品質管理のもと製造</p>
              </div>
              
              <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center mb-3">
                  <i className="ri-truck-line text-green-800 text-xl"></i>
                </div>
                <h5 className="font-bold text-green-800 mb-2">全国配送</h5>
                <p className="text-sm text-gray-600">迅速・安全な配送サービス</p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg border-2 border-green-800 shadow-lg">
              <h4 className="text-xl font-bold text-green-800 mb-4">会社情報</h4>
              <div className="space-y-2 text-gray-700">
                <p><strong>会社名：</strong>株式会社MELM</p>
                <p><strong>代表者：</strong>宮下　亜希</p>
                <p><strong>所在地：</strong>〒546-0043 大阪府大阪市東住吉区駒川3-27-39 プレジオールKOMAGAWA 204</p>
                <p><strong>電話番号：</strong>080-2466-3126 / 050-8894-7919</p>
                <p><strong>事業内容：</strong>美容商材の企画・製造・販売、通信販売事業</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
